import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "job-handler"
}
const _hoisted_2 = { class: "job-header" }
const _hoisted_3 = { class: "job-id" }
const _hoisted_4 = { class: "job-desc" }
const _hoisted_5 = {
  key: 0,
  class: "job-progress"
}
const _hoisted_6 = { class: "progress-bar" }
const _hoisted_7 = { class: "progress-text" }
const _hoisted_8 = {
  key: 1,
  class: "job-error"
}
const _hoisted_9 = {
  key: 2,
  class: "job-success"
}
const _hoisted_10 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, { name: "job-handler-fade-slide" }, {
    default: _withCtx(() => [
      ($setup.visible && $setup.store.jobs.size > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($setup.hasActiveJobs())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "job-handler-close",
                  onClick: _cache[0] || (_cache[0] = $event => ($setup.clearJob(Array.from($setup.store.jobs.keys())[0]))),
                  title: "Cancel Job"
                }, "×"))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.jobs, ([jobId, job]) => {
              return (_openBlock(), _createElementBlock("div", {
                key: jobId,
                class: "job-item"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, "Job: " + _toDisplayString(jobId.substring(0, 8)) + "...", 1 /* TEXT */),
                  _createElementVNode("span", {
                    class: _normalizeClass(["job-status", job.status])
                  }, _toDisplayString(job.status), 3 /* TEXT, CLASS */)
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString($setup.getJobDescription(job)), 1 /* TEXT */),
                (job.status === 'pending' || job.status === 'running')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                          class: "progress-fill",
                          style: _normalizeStyle({ width: (job.progress || 0) + '%' })
                        }, null, 4 /* STYLE */)
                      ]),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(job.progress || 0) + "%", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (job.status === 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Error: " + _toDisplayString(job.error), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (job.status === 'done')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Completed successfully"))
                  : _createCommentVNode("v-if", true),
                (job.status === 'pending')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      onClick: $event => ($setup.clearJob(jobId)),
                      class: "cancel-job-btn"
                    }, "Cancel", 8 /* PROPS */, _hoisted_10))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}